import { render, staticRenderFns } from "./StowageInstructionEdit.vue?vue&type=template&id=f548ee52&scoped=true"
import script from "./StowageInstructionEdit.vue?vue&type=script&ts=true&lang=js"
export * from "./StowageInstructionEdit.vue?vue&type=script&ts=true&lang=js"
import style0 from "./StowageInstructionEdit.vue?vue&type=style&index=0&id=f548ee52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f548ee52",
  null
  
)

export default component.exports